import React from "react";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { IconButton } from "@mui/material";
import { useIntl } from "react-intl";

import { type Classification, type ClassificationConfiguration, classificationConfigurationSchema } from "@/schemas";
import { useUpdateClassification } from "@/hooks/classifications";

import { ClassificationConfigurationModal } from "../classification-configuration-modal";

interface ClassificationEditButtonProps {
	readonly classification: Classification;
}

export const ClassificationEditButton: React.FC<ClassificationEditButtonProps> = ({ classification }) => {
	const intl = useIntl();

	const [showEdit, setShowEdit] = React.useState(false);
	const { mutateAsync: updateClassificationAsync, error } = useUpdateClassification(classification.id);

	const handleSubmit = async (data: ClassificationConfiguration): Promise<void> => {
		try {
			await updateClassificationAsync(data);
			setShowEdit(false);
		} catch {
			/* Handled */
		}
	};

	return (
		<>
			<ClassificationConfigurationModal
				open={showEdit}
				onClose={() => setShowEdit(false)}
				onSubmit={handleSubmit}
				error={error}
				defaultValues={classificationConfigurationSchema(intl).parse(classification)}
			/>
			<IconButton onClick={() => setShowEdit(true)} data-testid="classification-edit-button__button__open-modal">
				<EditOutlinedIcon />
			</IconButton>
		</>
	);
};
